import "./index.scss";
import { Records, Selected } from "../../ACP/constant";

const Footer = ({
  isSelected,
  selected = [],
  totalObjects = 0,
  handleSave = null,
  handleCancel = null,
  isSaveEnabled,
}) => {
  return (
    <div className={`footer ${handleSave !== null ? "adjustTop" : ""}`}>
      <div className="record-count">
        {totalObjects} {Records}{" "}
        {isSelected ? (
          <span>
            , {selected?.length} {Selected}
          </span>
        ) : null}
      </div>
      <div className="myproject-action-buttons">
        {handleSave && (
          <button
            type="button"
            className="button-layout saveBtn"
            variant="primary"
            onClick={handleSave}
            disabled={isSaveEnabled}
          >
            Save
          </button>
        )}
        {handleCancel && (
          <button
            type="button"
            className="button-layout cancelBtn"
            variant="secondary"
            onClick={handleCancel}
            disabled={isSaveEnabled}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
};

export default Footer;
